import React, { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'
import { useSearchParams } from 'react-router-dom'
import AdminSeatChecker from './AdminSeatChecker.jsx'
import AdminGalleryPage from './AdminGalleryPage.jsx'
import AdminGalleryUploadPortal from './AdminGalleryUploadPortal.jsx'
import '../styles/AdminDashboardResponsive.css'
import '../utils/adminRsvpDeadlineColumnEnhancer.js'

function AdminGallerySidebarPortal({ onOpen }) {
  const [target, setTarget] = useState(null)

  useEffect(() => {
    let slot = null

    function attachSlot() {
      const nav = document.querySelector('.adm-sidebar-nav')
      if (!nav) return

      const existing = nav.querySelector('.adm-gallery-nav-slot')
      if (existing) {
        slot = existing
        setTarget(existing)
        return
      }

      slot = document.createElement('div')
      slot.className = 'adm-gallery-nav-slot'

      const actionsLabel = [...nav.children].find((element) => (
        element.classList?.contains('adm-sidebar-label') &&
        String(element.textContent || '').trim().toLowerCase() === 'actions'
      ))
      if (actionsLabel) nav.insertBefore(slot, actionsLabel)
      else nav.appendChild(slot)
      setTarget(slot)
    }

    attachSlot()
    const observer = new MutationObserver(attachSlot)
    observer.observe(document.body, { childList: true, subtree: true })

    return () => {
      observer.disconnect()
      if (slot?.parentNode) slot.parentNode.removeChild(slot)
    }
  }, [])

  if (!target) return null

  return createPortal(
    <button type="button" className="adm-sidebar-btn" onClick={onOpen}>
      <span className="adm-sidebar-icon">📷</span> Gallery
    </button>,
    target
  )
}

export default function AdminInvitationsShell() {
  const [searchParams, setSearchParams] = useSearchParams()
  const activeTab = String(searchParams.get('tab') || 'invitations').trim().toLowerCase()

  function navigateToTab(tab) {
    setSearchParams((current) => {
      const next = new URLSearchParams(current)
      next.set('tab', tab)
      if (tab !== 'bookings') next.delete('bookingView')
      return next
    })
  }

  if (activeTab === 'gallery') {
    return (
      <>
        <AdminGalleryPage onNavigateTab={navigateToTab} />
        <AdminGalleryUploadPortal />
      </>
    )
  }

  return (
    <>
      <AdminSeatChecker />
      <AdminGallerySidebarPortal onOpen={() => navigateToTab('gallery')} />
    </>
  )
}
